export default function MediaSection() {
  const mediaItems = [
    {
      id: 1,
      title: '独家对话：业内人士揭秘综艺选秀暗箱操作流程',
      duration: '12:38',
      views: '89.2万',
      image: 'https://readdy.ai/api/search-image?query=dramatic%20close%20up%20of%20microphone%20at%20press%20conference%20with%20blurred%20journalists%20in%20background%2C%20warm%20spotlight%2C%20dark%20atmospheric%20lighting%2C%20professional%20news%20gathering%20scene%2C%20cinematic%20mood&width=700&height=500&seq=media-01&orientation=landscape',
    },
    {
      id: 2,
      title: '现场直击：品牌发布会后台真实一幕流出',
      duration: '08:15',
      views: '67.8万',
      image: 'https://readdy.ai/api/search-image?query=cinematic%20scene%20of%20television%20studio%20control%20room%20with%20multiple%20screens%20showing%20live%20feeds%2C%20warm%20amber%20glow%2C%20dark%20technical%20environment%2C%20broadcast%20journalism%20aesthetic%2C%20professional%20atmosphere&width=700&height=500&seq=media-02&orientation=landscape',
    },
    {
      id: 3,
      title: '深度追踪：网红直播翻车全记录与后续进展',
      duration: '15:42',
      views: '102.5万',
      image: 'https://readdy.ai/api/search-image?query=artistic%20shot%20of%20spotlight%20illuminating%20empty%20stage%20with%20microphone%20stand%2C%20dramatic%20shadows%2C%20warm%20golden%20light%2C%20entertainment%20venue%20atmosphere%2C%20concert%20hall%20mood%2C%20cinematic&width=700&height=500&seq=media-03&orientation=landscape',
    },
    {
      id: 4,
      title: '最新快报：今晨三位艺人相继被拍现身机场',
      duration: '05:20',
      views: '45.3万',
      image: 'https://readdy.ai/api/search-image?query=close%20up%20dramatic%20shot%20of%20breaking%20news%20alert%20on%20smartphone%20held%20in%20darkness%2C%20warm%20notification%20glow%2C%20modern%20digital%20journalism%2C%20intimate%20atmospheric%20lighting%2C%20cinematic%20mood&width=700&height=500&seq=media-04&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 bg-accent-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-play-circle-line"></i>
            Video Highlights
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500">精选黑料相关精彩视频内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden hover:border-background-300/60 transition-all group cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-950/20 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-accent-400 text-lg ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-background-950/80 text-foreground-100 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm font-bold text-foreground-200 leading-snug mb-1.5 line-clamp-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600">{item.views} 次观看</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}